import { render, staticRenderFns } from "./BundleVarianComponentDetails.vue?vue&type=template&id=6d9853cb&"
import script from "./BundleVarianComponentDetails.vue?vue&type=script&lang=js&"
export * from "./BundleVarianComponentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports